export default __webpack_public_path__ + "static/media/tiger.38d95bb6.jpg";